
import React, { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";

const translations = {
  en: {
    title: "Get in Touch",
    subtitle: "Book Your Free Consultation",
    name: "Full Name",
    email: "Email Address",
    phone: "Phone Number",
    country: "Country of Residence",
    study: "Preferred Study Destination",
    message: "Your Message",
    submit: "Book Consultation",
    success: "Thank you! We'll contact you soon.",
    error: "Something went wrong. Please try again."
  },
  ar: {
    title: "تواصل معنا",
    subtitle: "احجز استشارتك المجانية",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    country: "بلد الإقامة",
    study: "وجهة الدراسة المفضلة",
    message: "رسالتك",
    submit: "احجز الاستشارة",
    success: "شكراً لك! سنتواصل معك قريباً.",
    error: "حدث خطأ ما. يرجى المحاولة مرة أخرى."
  },
  so: {
    title: "Nala Soo Xiriir",
    subtitle: "Ballan Ka Sameyso La-talinta Bilaashka ah",
    name: "Magaca Oo Buuxa",
    email: "Ciwaanka Emailka",
    phone: "Lambarka Telefoonka",
    country: "Wadanka Aad Ku Nooshahay",
    study: "Halka Aad Rabto Inaad Wax Ku Barato",
    message: "Fariintaada",
    submit: "Ballan Ka Sameyso La-talinta",
    success: "Waad ku mahadsantahay! Waan kula soo xiriiri doonaa dhawaan.",
    error: "Wax qalad ah ayaa dhacay. Fadlan isku day mar kale."
  }
};

function ContactForm({ language }) {
  const { toast } = useToast();
  const content = translations[language];
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    study: "",
    message: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    // For now, we'll just show a success message
    toast({
      title: content.success,
      duration: 3000
    });
    setFormData({
      name: "",
      email: "",
      phone: "",
      country: "",
      study: "",
      message: ""
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{content.title}</h2>
          <p className="text-lg text-muted-foreground">{content.subtitle}</p>
        </motion.div>

        <div className="max-w-2xl mx-auto">
          <motion.form
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            onSubmit={handleSubmit}
            className="space-y-6"
          >
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium mb-2">{content.name}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full p-2 rounded-md border border-input bg-background"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">{content.email}</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-2 rounded-md border border-input bg-background"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">{content.phone}</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full p-2 rounded-md border border-input bg-background"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">{content.country}</label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                  className="w-full p-2 rounded-md border border-input bg-background"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">{content.study}</label>
              <select
                name="study"
                value={formData.study}
                onChange={handleChange}
                required
                className="w-full p-2 rounded-md border border-input bg-background"
              >
                <option value="">Select destination</option>
                <option value="uk">United Kingdom</option>
                <option value="malaysia">Malaysia</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">{content.message}</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="w-full p-2 rounded-md border border-input bg-background"
              ></textarea>
            </div>
            <Button type="submit" className="w-full">
              {content.submit}
            </Button>
          </motion.form>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
